import { useState } from "react";
import { auth, db } from "../firebase";
import {
  createUserWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import "./SignupPage.css";

function SignupPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");

  const navigate = useNavigate();

  // ✅ Email/password sign-up
  const handleSignup = async () => {
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;

      await setDoc(doc(db, "users", user.uid), {
        uid: user.uid,
        email: user.email,
        name: name,
        balance: 0,
        isAdmin: false,
        createdAt: serverTimestamp(),
      });

      navigate("/games");
    } catch (error) {
      alert("Signup failed: " + error.message);
    }
  };

  // ✅ Google sign-up
  const handleGoogleSignup = async () => {
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      await setDoc(
        doc(db, "users", user.uid),
        {
          uid: user.uid,
          email: user.email,
          name: user.displayName,
          balance: 0,
          isAdmin: false,
          createdAt: serverTimestamp(),
        },
        { merge: true } // won't overwrite if user exists
      );

      navigate("/games");
    } catch (error) {
      alert("Google Sign-In failed: " + error.message);
    }
  };

  return (
    <div className="signup-page-wrapper">
      <nav className="navbar">
        <div className="logo">Pinoy Games</div>
        <ul className="menu">
          <li><a href="/">Back to Home</a></li>
        </ul>
      </nav>

      <div className="signup-container">
        <div className="signup-card">
          <h2>Create Account</h2>
          <input
            type="text"
            placeholder="Full Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <input
            type="email"
            placeholder="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type="password"
            placeholder="Password (min 6 characters)"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button onClick={handleSignup}>Sign Up</button>

          <div className="or-separator">or</div>
          <button className="google-btn" onClick={handleGoogleSignup}>
            Continue with Google
          </button>
        </div>
      </div>
    </div>
  );
}

export default SignupPage;
